export default "__VITE_ASSET__CeAwtYBc__"